import {
  DropdownItem,
  DynamicMultiSelectDropdownProps,
} from "../../Interfaces/dropdownInterfaces";
import React from "react";
import { LinkOutlined } from "@ant-design/icons";
import { StaticMultiSelectDropdown } from "./StaticMultiSelectDropdown";

const DynamicMultiSelectDropdown = <T extends DropdownItem>({
  inputId,
  dropdown,
  getData,
  onChange,
  value,
  withSelectAll = false,
  withTagBox,
  allDefaultValue,
}: DynamicMultiSelectDropdownProps<T>) => {
  const [options, setOptions] = React.useState<Array<T>>([]);
  React.useEffect(() => {
    getData(inputId)
      .then((res) => {
        setOptions(res);
      })
      .catch((e) => {
        setOptions([]);
      });
  }, [inputId]);

  if (!options) {
    return <></>;
  }

  const items = options.map((option) => {
    const accountOption = option as T & { hasConnectedAccount?: boolean };
    return {
      ...option,
      prefix:
        option.prefix ??
        (accountOption.hasConnectedAccount ? (
          <LinkOutlined title="اکانت متصل" />
        ) : undefined),
    };
  });

  return (
    <StaticMultiSelectDropdown
      items={items}
      label={dropdown.placeholder}
      name={dropdown.name}
      value={value}
      onChange={onChange}
      className={dropdown.className}
      withSelectAll={withSelectAll}
      extraLabel={dropdown.extraLabel}
      withTagBox={withTagBox}
      allDefaultValue={allDefaultValue}
    />
  );
};

export default DynamicMultiSelectDropdown;
